import React, { Component } from 'react'
import { graphql } from 'gatsby'
import he from 'he'

import SEO from '../components/seo'
import Header from '../components/header'
import Footer from '../components/footer'

import Room from "../components/room/Room"

class RoomTemplate extends Component {

  render() {
    let room = this.props.data.wpRoom

    return (
      <>
        <SEO title={he.decode(room.seo.title)} bodyClass={'single-room'} description={room.seo.metaDesc} />
        <Header page={"isRoom"} />
        <Room {...room} />
        <Footer height={147} />
      </>
    )
  }
}

export const roomQuery = graphql`
  query ($id: String!) {
    wpRoom(id: {eq: $id}) {
      title
      slug
      seo {
        title
        metaDesc
        opengraphTitle
        opengraphDescription
        opengraphImage {
          sourceUrl
          altText
          localFile {
            childImageSharp {
              original {
                src
                width
                height
              }
            }
          }
        }
      }
      acf {
        title
        button {
          text
          link
        }
        gallery {
          localFile {
            childImageSharp {
              fluid(maxWidth: 1200, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
          altText
        }
        description
        location
        inside {
          text
        }
        outside {
          text
        }
        googleMap {
          latitude
          longitude
        }
        reviews {
          stars
          title
          review
          reviewer
        }
        card {
          title
          bedrooms
          sleeps
        }
      }
    }
  }
`

export default RoomTemplate
